import React, { useEffect, useState } from "react";
import makeStyles from '@mui/styles/makeStyles';


import Grid from '@mui/material/Grid2';

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    height: "100%",
    position: "relative",
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: 0,
  },
  iframeWithHiddenWatermark: {
    height: "calc(100% + 24px)",
  },
  watermarkOverlay: {
    position: "absolute",
    bottom: 0,
    right: 0,
    height: "24px",
    width: "140px",
    pointerEvents: "auto",
    zIndex: 9999,
  },
  watermarkBlur: {
    backdropFilter: "blur(5px)",
  },
}));

const useWatermarkStrategy = () => {
  const [strategy, setStrategy] = useState<string>('blur');

  useEffect(() => {
    const strategy = localStorage.getItem("watermarkStrategy");
    if (strategy) {
      setStrategy(strategy);
    }
  });

  return strategy;
}

type DashboardProps = {
  url: string;
};

export const Dashboard = ({ url }: DashboardProps) => {
  const styles = useStyles();
  const watermarkStrategy = useWatermarkStrategy();

  return (
    <Grid direction={'column'} className={styles.container}>
      <iframe 
        className={`${styles.iframe} ${watermarkStrategy === 'hide' ? styles.iframeWithHiddenWatermark : ''}`}
        src={url} 
        frameBorder={0}
      />
      {/* <div className={`${styles.watermarkOverlay} ${watermarkStrategy === 'blur' ? styles.watermarkBlur : ''}`}> </div> */}
    </Grid>
  );
};
